import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import positionDropdown from '@utils/dropdownPosition';

const ButtonWithDropdown = ({ buttonLabel, dropdownItems }) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const containerRef = useRef(null);
  const triggerRef = useRef(null);
  const menuRef = useRef(null);

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!isDropdownOpen) return;
    const rafId = requestAnimationFrame(() => {
      if (triggerRef.current && menuRef.current) {
        positionDropdown(triggerRef.current, menuRef.current);
      }
    });
    const handleResize = () => {
      if (triggerRef.current && menuRef.current) {
        positionDropdown(triggerRef.current, menuRef.current);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener('resize', handleResize);
    };
  }, [isDropdownOpen]);

  return (
    <div className={`dropdown mb-4 ${isDropdownOpen ? 'show' : ''}`} ref={containerRef}>
      <button
        ref={triggerRef}
        className="btn btn-primary dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        onClick={toggleDropdown}
        aria-haspopup="true"
        aria-expanded={isDropdownOpen}
      >
        {buttonLabel}
      </button>
      <div
        ref={menuRef}
        className={`dropdown-menu animated--fade-in ${isDropdownOpen ? 'show' : ''}`}
        aria-labelledby="dropdownMenuButton"
        style={{ fontSize: '13px' }}
      >
        {dropdownItems.map((item, index) => (
          item.href ? (
            <>
              <a className="dropdown-item" href={item.href} key={index} data-dd-item>
                {item.label}
              </a>
              {index !== dropdownItems.length - 1 && <div className="dropdown-divider"></div>}
            </>
          ) : (
            <>
              <button className="dropdown-item" type="button" onClick={item.onClick} key={index} data-dd-item>
                {item.label}
              </button>
              {index !== dropdownItems.length - 1 && <div className="dropdown-divider"></div>}
            </>
          )
        ))}
      </div>
    </div>
  );
};

ButtonWithDropdown.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  dropdownItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string,
      onClick: PropTypes.func,
    })
  ).isRequired,
};

export default ButtonWithDropdown;
